// HM-305: Tabs wrapper Radix con palette warm. Pattern shadcn-style.
// Usato in cluster 19/20/22 (KNX tabs, Ospiti tabs).

import * as TabsPrimitive from '@radix-ui/react-tabs';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '../lib/cn';

export const Tabs = TabsPrimitive.Root;

export const TabsList = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('inline-flex items-center gap-1 border-b border-border-base', className)}
    {...props}
  />
));
TabsList.displayName = 'TabsList';

export const TabsTrigger = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'relative px-4 py-2.5 text-sm font-medium text-text-secondary',
      'transition-colors hover:text-text-primary',
      'data-[state=active]:text-accent-primary-text',
      'data-[state=active]:after:absolute data-[state=active]:after:left-0 data-[state=active]:after:right-0',
      'data-[state=active]:after:-bottom-px data-[state=active]:after:h-0.5',
      'data-[state=active]:after:bg-accent-primary',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-primary',
      className,
    )}
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

export const TabsContent = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content ref={ref} className={cn('mt-4 outline-none', className)} {...props} />
));
TabsContent.displayName = 'TabsContent';
